
























































































import { Component, Vue, Prop } from "vue-property-decorator";
import { LogPrecificacaoModel } from "@/models/administracao/log-precificacao/LogPrecificacaoModel";
import { moneyMaskProperties } from "@/models/VuetifyMoneyModel";

@Component
export default class DetalhesLogPrecificacao extends Vue {
  @Prop({ required: true })
  detalhesLogServico!: LogPrecificacaoModel; 

  moneyMaskProperties = moneyMaskProperties;

  get valorSaidaPrestador() {
    return this.detalhesLogServico.valorSaida || 0;
  }

  get valorKmExcedido() {
    return this.detalhesLogServico.valorCadaKilometroExcedido || 0;
  }

  get valorTotalKmExcedido() {
    return this.detalhesLogServico.valorTotalKMExcedido || 0;
  }

  get valorTotalPrestador() {
    return this.detalhesLogServico.valorPrestador || 0;
  }

  get valorPedagio() {
    return this.detalhesLogServico.valorPedagio || 0;
  }

  get valorAdicionalGuincho() {
    return this.detalhesLogServico.valorAdicionalGuincho || 0;
  }

  get valorHoraTrabalhada() {
    return this.detalhesLogServico.valorHoraTrabalhada || 0;
  }

  get valorGenteResolve() {
    return this.detalhesLogServico.valorLucroTotal || 0;
  }

  get qtdKmSolicitacao() {
    return this.detalhesLogServico.kmQueSeraPercorrido || 0;
  }

  get valorHoraParada() {
    return this.detalhesLogServico.valorHoraParada || 0;
  }

  get valorPatins() {
    return this.detalhesLogServico.valorPatins || 0;
  }

  get agravo() {
    return this.detalhesLogServico.agravo || 0;
  }

  get valorAgravo() {
    return this.detalhesLogServico.valorAgravo || 0;
  }

  get desconto() {
    return this.detalhesLogServico.desconto || 0;
  }

  get valorDesconto() {
    return this.detalhesLogServico.valorDesconto || 0;
  }

  get kmQueSeraExcedido() {
    return this.detalhesLogServico.kmQueSeraExcedido || 0;
  }
}
